import{jsx as s}from"react/jsx-runtime";import m from"classnames";import n from"../../assets/button.module.scss";const r=({children:t,className:o})=>s("div",{className:m(n.btn__content,o),children:t});export{r as Content};
